<template>
    <div class="text-center d-flex">
        <!-- <v-list dense align="center" :color="color" class="transparent"> -->
        <div>
            <slot name="overlay"></slot>
            <profile-picture v-if="$auth.loggedIn" size="60"></profile-picture>
            <slot name="ribbon"></slot>
        </div>
        <div
            v-if="$auth.loggedIn"
            class="pl-3 align-items-center pcard-text d-flex"
        >
            <div
                v-if="user.name"
                class="text-capitalize black--text mb-0 text-truncate"
                :class="titleSize"
            >
                {{ name ? name.split(" ")[0] : "" }}
            </div>
        </div>

        <profile-membership
            class="py-0"
            membership-class="body-1"
        ></profile-membership>

        <!-- <v-list-item>
      <v-list-item-content class="py-0">
        <v-list-item-subtitle
          v-if="user.name"
          class="text-capitalize white--text mb-0"
          :class="titleSize"
        >
          Hi, {{ name ? name.split(' ')[0] : '' }}
        </v-list-item-subtitle>
        <profile-membership
          class="py-0"
          membership-class="body-1"
        ></profile-membership>
      </v-list-item-content>
    </v-list-item> -->
        <!-- </v-list> -->
    </div>
</template>

<script>
import ProfilePicture from "@/components/fairplay/Profile/ProfilePicture"
import ProfileMembership from "@/components/fairplay/Profile/ProfileMembership"

export default {
    components: { ProfilePicture, ProfileMembership },
    props: {
        titleSize: {
            type: String,
            default: "",
            required: false
        },
        color: { type: String, default: "" }
        // membershipClasses: {
        //   type: String,
        //   default: '',
        //   required: false
        // }
        // rates: { type: Object, default: () => {}, required: true },
    },
    computed: {
        name() {
            return this.$store.state.profile.data.name
        },
        user() {
            return this.$store.state.profile.data
        }
    }
}
</script>
